import { DropdownWrapper, LeftWrapper, RightWrapper } from '../Dropdown.styles';
import {
    FilterWrapper,
    StyledDropdownWithLabel
} from './SearchInitiationMobile.styles';

const maxPriceLabel = 'Max price';
const priceFrequencyLabel = 'Price per';

const priceFrequencyOptions: { [key: PriceFrequency]: string } = {
    per_month: 'pcm',
    per_week: 'pcw'
};

const priceOptions = [
    '25',
    '50',
    '75',
    '100',
    '125',
    '150',
    '175',
    '200',
    '225',
    '250',
    '275',
    '300',
    '325',
    '350',
    '375',
    '400',
    '425',
    '450',
    '475',
    '500',
    '550',
    '600',
    '650',
    '700',
    '750',
    '800',
    '850',
    '900',
    '950',
    '1000',
    '1250',
    '1500',
    '1750',
    '2000',
    '2500',
    '3000',
    '3500',
    '4000',
    '4500',
    '5000',
    '7500'
];

type prices = typeof priceOptions[number];

export type PriceFrequency = '' | 'per_week' | 'per_month' | string;
export type PriceMax = prices;

type SelectPriceToRentProps = {
    value: {
        priceMax: PriceMax;
        priceFrequency: PriceFrequency;
    };
    onChange: ({
        priceMax,
        priceFrequency
    }: {
        priceMax: PriceMax;
        priceFrequency: PriceFrequency;
    }) => void;
};

export const SelectPriceToRent = ({
    value,
    onChange
}: SelectPriceToRentProps) => {
    const priceMaxOptions = priceOptions;

    const priceFrequency = priceFrequencyOptions[value.priceFrequency];

    return (
        <FilterWrapper>
            <DropdownWrapper>
                <LeftWrapper>
                    <StyledDropdownWithLabel
                        id="mobile_price_frequency-filter"
                        data-testid="price_frequency-filter-select_mobile"
                        onChange={(e) => {
                            onChange({
                                ...value,
                                priceFrequency: e.target.value
                            });
                        }}
                        value={value.priceFrequency}
                        name="priceFrequency"
                        label={priceFrequencyLabel}
                        aria-label="Price Frequency"
                        hasBorderRadius
                    >
                        <option value="per_month">Month</option>
                        <option value="per_week">Week</option>
                    </StyledDropdownWithLabel>
                </LeftWrapper>

                <RightWrapper>
                    <StyledDropdownWithLabel
                        onChange={(e) => {
                            onChange({
                                ...value,
                                priceMax: e.target.value
                            });
                        }}
                        value={value.priceMax}
                        name="price_max_monthly"
                        id="price_max_monthly_mobile"
                        aria-label="Max Price monthly"
                        data-testid="max_price_mobile"
                        label={maxPriceLabel}
                        hasBorderRadius
                    >
                        <option value="">No max</option>
                        {priceMaxOptions.map((priceMaxOption, index) => {
                            const price = new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'GBP',
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0
                            }).format(Number(priceMaxOption));

                            return (
                                <option
                                    value={priceMaxOption}
                                    key={`quicksearch_price_max_${index}`}
                                >
                                    {price} {priceFrequency}
                                </option>
                            );
                        })}
                    </StyledDropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
